
export default ({reloadUser}) => async (_) => {
    await reloadUser()
}